import { Pipe } from '@angular/core';
import { isArray } from '../utils/utils';
var JoinPipe = (function () {
    function JoinPipe() {
    }
    JoinPipe.prototype.transform = function (input, character) {
        if (character === void 0) { character = ''; }
        if (!isArray(input)) {
            return input;
        }
        return input.join(character);
    };
    return JoinPipe;
}());
export { JoinPipe };
JoinPipe.decorators = [
    { type: Pipe, args: [{
                name: 'join'
            },] },
];
/** @nocollapse */
JoinPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=join.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/array/join.pipe.js
// module id = 239
// module chunks = 103